module.exports = __webpack_public_path__ + "img/gear.5c640aac.svg";